"use strict";

var _interopRequireDefault = require("E:/start-cms/back-front/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.array.sort");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("E:/start-cms/back-front/node_modules/@babel/runtime/helpers/asyncToGenerator"));

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.find");

var _objectSpread2 = _interopRequireDefault(require("E:/start-cms/back-front/node_modules/@babel/runtime/helpers/objectSpread2"));

var _dashboard = require("@/api/dashboard");

var _vuex = require("vuex");

var _microApp = _interopRequireDefault(require("@micro-zoe/micro-app"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: 'Dashboard',
  data: function data() {
    return {
      temp: {},
      list: [],
      formVisible: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['apps', 'user', 'token', 'authorize'])),
  created: function created() {
    var _this = this;

    // 获取看板
    (0, _dashboard.getList)().then(function (res) {
      _this.list = res.data;
    });
  },
  methods: {
    getEntry: function getEntry(item) {
      var app = this.apps.find(function (app) {
        return app.name == item.app;
      }) || {};

      if (typeof app == 'undefined') {
        return '/';
      }

      if (app.entry.indexOf('http') == -1) {
        return window.location.origin + app.entry;
      }

      return app.entry;
    },
    beforeMount: function beforeMount(item) {
      var app = this.apps.find(function (app) {
        return app.name == item.app;
      }) || {};
      var route = item.route || {
        path: '/dashboard'
      };

      _microApp.default.setData(item.name, {
        app: app,
        route: route,
        user: this.user,
        token: this.token,
        authorize: this.authorize
      });
    },
    // 监听子应用数据
    dataChange: function dataChange(e) {
      var _this2 = this;

      var data = e.detail.data;

      if (data.route) {
        // 此处不允许控制基座路由
        setTimeout(function () {
          _this2.$router.push({
            path: '/dashboard'
          });
        }, 1000);
      } // 监听应用消息


      if (data.msg) {
        this.$store.dispatch('app/sendMsg', data.msg);
      }
    },
    handleUpdate: function handleUpdate(command) {
      var item = this.list[command.index];

      switch (command.action) {
        case 'update':
          this.temp = item;
          this.formVisible = true;
          break;

        case 'hidden':
          (0, _dashboard.updateStatus)({
            id: item.id,
            status: 0
          });
          this.list.splice(command.index, 1);
          break;

        default:
          break;
      }
    },
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _yield$update, code, msg;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _dashboard.update)({
                  id: this.temp.id,
                  sort: this.temp.sort,
                  title: this.temp.title,
                  status: this.temp.status
                });

              case 2:
                _yield$update = _context.sent;
                code = _yield$update.code;
                msg = _yield$update.msg;

                if (!code) {
                  this.$message.success(msg);
                  this.formVisible = false;
                } else {
                  this.$message.error(msg);
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }

      return handleSubmit;
    }()
  }
};
exports.default = _default;